import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="security-systems-patrols-road"
export default class extends Controller {
  static targets = ["complexSchedule", "complexDaysOfWeek", "complexTimes", "scheduleDetails"]

  connect() {
    this.toggleScheduleFields()
  }

  toggleScheduleFields() {
    this.complexScheduleTarget.style.display = 'block'
  }

  submitForm(event) {
    event.preventDefault()
    const daysOfWeek = Array.from(this.complexDaysOfWeekTargets).filter(target => target.checked).map(target => target.value).join(',')
    const times = this.complexTimesTarget.value
    this.scheduleDetailsTarget.value = `${daysOfWeek}|${times}`
    
    this.element.submit()
  }
}
